<template>
    <div>
        <!-- header section01 -->
        <Header/>
        <!-- 근무조건 section02 -->
        <Section02/>
        <!-- 복리후생 section03 -->
        <Section03/>
        <!-- 근무환경 section04 -->
        <Section04/>
        <!-- 지원방법 section05 -->
        <Section05/>
    </div>
</template>
<script>
import Header from './RecruitSection01'
import Section02 from './RecruitSection02'
import Section03 from './RecruitSection03'
import Section04 from './RecruitSection04'
import Section05 from './RecruitSection05'
export default {
	name: 'RecruitComponent',
	components: {
		Header, Section02, Section03, Section04, Section05
	},
	mounted () {
		this.$store.dispatch('scroll', 0)
	}
}
</script>
